module.exports = __webpack_public_path__ + "img/prod_share_btm.eb98f347.png";